// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "Your Api Key",
    authDomain: "Your Auth Domain",
    databaseURL: "Your Database Url",
    projectId: "Your Project Id",
    storageBucket: "Your StorageBucket url",
    messagingSenderId: "Your Sender Id"
  },
    public_key: `-----BEGIN PUBLIC KEY-----
MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgHNAOvWOHaJ0iIP3nfuidpQH2ygV
BSo6bej0ZOLh6kLKa6oj4/VHrw5tBh3OuGo1qziU9WlCPQu+/utQt42nTkOaCkEf
I6T6nM99iIMZ+K0IakRTXALBn5ApJZA7BP13pHnilOnEBSvxnkDRbtTKc5hKhUK+
MhersEjSxFglf4vXAgMBAAE=
-----END PUBLIC KEY-----`,
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
